import { NavigateFunction } from 'react-router-dom'
import { getConfig } from '../useConfig'
import { CreateClientOptions } from '@workos-inc/authkit-react/src/types'

const createOnRedirectCallback = (navigate: NavigateFunction) => {
  return (appState) => {
    navigate(appState?.returnTo || window.location.pathname)
  }
}
export const createAuthProviderConfig = (navigate: NavigateFunction) => {
  const config = getConfig()
  return {
    apiHostname: config?.WORKOS_AUTH_URL,
    clientId:
      config?.WORKOS_AUTH_CLIENT_ID || 'client_01J8A2BVCYVQSP8N6M4AABT7ZE',
    onRedirectCallback: createOnRedirectCallback(navigate),
  } satisfies CreateClientOptions & { clientId: string }
}
